// src/components/routes/RouteForm.jsx
import React, { useEffect, useState } from "react";
import {
    Form, FormGroup, Label, Input, Row, Col, Button, FormFeedback
} from "reactstrap";
import Session from '../../auth/Session';

const InvoiceDetailForm = ({ detailItem, subCustomerId, apiBaseUrl, onSuccess, onCancel }) => {
    const [formData, setFormData] = useState({
        id: 0,
        routeId: null,
        daysOnRoute: 0,
        expectedDays: 0,
        invoiceId: null,
        surchargeId: null,
    });

    const [subCustomers, setSubCustomers] = useState([]);
    const [surcharges, setSurcharges] = useState([]);
    const [transactionTypes, setTransactionTypes] = useState([]);
    const [surcharge, setSurcharge] = useState({
        id: 0,
        description: "",
        percentage: 0,
        dollarAmount: 0,
        surchargeTypeId: "1",
    });

    const [errors, setErrors] = useState({});
    const surchargesApi = `/api/surcharges/BySubCustomer/${subCustomerId}`;

    useEffect(() => {
        console.log('surcharge')
        console.log(detailItem);
        if (detailItem) {
            setFormData({
                id: 0,
                routeId: detailItem.routeId,
                daysOnRoute: 0,
                expectedDays: 0,
                invoiceId: detailItem.invoiceId,
                surchargeId: null,
            });
        }
    }, [detailItem]);

    useEffect(() => {
        const loadData = async () => {
            const token = await Session.getToken();
            // Load dropdown data
            const [res] = await Promise.all([
                fetch(surchargesApi, { headers: { Authorization: `Bearer ${token}` } }),
            ]);

            if (!res.ok) throw new Error(`${res.status} ${await res.text()}`);
            const data = await res.json();
            setSurcharges((data || []).filter(s => s.isActive !== false));
        };
        loadData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(p => ({ ...p, [name]: value }));
        let item = surcharges.find(s => `${s.id}` === value);
        if (item) {
            setSurcharge(item);
        }
    };

    const validate = () => {
        const v = {};
        if (!formData.surchargeId) v.surcharge = "Surcharge is required";
        setErrors(v);
        return Object.keys(v).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const url = `/api/invoicing/add-surcharge`;

        const body = {
            invoiceId: formData.invoiceId,
            surchargeId: formData.surchargeId,
            routeId: formData.routeId,
        };
        const token = await Session.getToken();

        const res = await fetch(url, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });

        if (!res.ok) {
            const t = await res.text();
            alert(`Save failed: ${res.status} ${t}`);
            return;
        }
        onSuccess(await res.json());
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col md={6}>
                    <Label>Route</Label>
                    <Input disabled value={detailItem.route?.name}/>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Surcharge</Label>
                        <Input
                            id="surchargeId"
                            name="surchargeId"
                            type="select"
                            value={formData.surchargeId || ""}
                            onChange={handleChange}
                            invalid={!!errors.surchargeId}
                        >
                            <option value="">-- Surcharge --</option>
                            {surcharges.map(sc => (
                                <option key={sc.id} value={sc.id}>
                                    {sc.description}
                                </option>
                            ))}
                        </Input>
                        <FormFeedback>{errors.surchargeId}</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label>Description</Label>
                        <Input disabled value={surcharge?.description} />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Surcharge Type</Label>
                        <Input disabled value={surcharge?.surchargeType?.name || "Dollar Amount"} />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    {`${surcharge.surchargeTypeId}` === '2' ? (
                        <FormGroup>
                            <Label>Percentage</Label>
                            <Input disabled name="percentage" type="number" step="0.01" value={Number(surcharge.percentage).toFixed(2)} />
                        </FormGroup>
                    ) : (
                        <>
                                {(`${surcharge.surchargeTypeId}` === '1' || `${surcharge.surchargeTypeId}` === '7' || `${surcharge.surchargeTypeId}` === '3' || `${surcharge.surchargeTypeId}` === '4') && (
                                <FormGroup>
                                    <Label>Dollar Amount</Label>
                                        <Input disabled name="dollarAmount" type="number" step="0.01" value={Number(surcharge.dollarAmount).toFixed(2)} />
                                </FormGroup>
                            )}
                        </>
                    )}
                </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2">
                <Button color="secondary" type="button" onClick={onCancel}>Cancel</Button>
                <Button color="primary" type="submit">{`${formData.id}` !== `0` ? "Update" : "Add Surcharge"}</Button>
            </div>
        </Form>
    );
};

export default InvoiceDetailForm;
